module.exports = __webpack_public_path__ + "fonts/polaris_c157a36e47c83ee97ece187618412a81.ttf";